import React from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import HorizontalRuleRoundedIcon from '@mui/icons-material/HorizontalRuleRounded';

import cn from '../../utils/cn';

const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>>(
  ({ className, ...props }, ref) => (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'peer size-4 shrink-0 rounded-sm border border-gray-dark ring-offset-background',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        'data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=checked]:text-white',
        'data-[state=indeterminate]:bg-primary data-[state=indeterminate]:border-primary data-[state=indeterminate]:text-white',
        'disabled:cursor-not-allowed disabled:border-gray-light',
        'data-[state=checked]:disabled:bg-primary-light data-[state=checked]:disabled:border-primary-light',
        'data-[state=indeterminate]:disabled:bg-primary-light data-[state=indeterminate]:disabled:border-primary-light',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
        {props.checked === 'indeterminate' ? <HorizontalRuleRoundedIcon className='size-3.5' /> : <CheckRoundedIcon className='size-3.5' />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export default Checkbox;
